ulekareApp.factory('C', function(){

	var nowDate = new Date();

	var validationFunctions = {
		'notBlank': function(params, value) {
			return value && value.length > 0;
		},
		'regexp': function(params, value) {
			var res = params.regexp.exec(value);
			return res !== null;
		},
		'email': function(params, value) {
			var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(value).toLowerCase());
		},
		'range': function(params, value) {
			return value && (params.min && value >= params.min) && (params.max && value <= params.max);
		},
		'length': function(params, value) {
			return value && (params.min && value.length >= params.min) && (params.max && value.length <= params.max);
		},
		'true': function(params, value) {
			return value && value === true;
		},
		'phoneNumber': function(params, value) {
			var phoneNumber = new libphonenumber.parsePhoneNumberFromString(value);
			return phoneNumber.number !== undefined && phoneNumber.isPossible();
		}
	};

	var formFieldsDefinition = {
		'question': {
			'name': 'question',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				}
			]
		},
		'problem': {
			'name': 'problem',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				}
			]
		},
		'firstName': {
			'name': 'firstName',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				}
			]
		},
		'lastName': {
			'name': 'lastName',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				}
			]
		},
		'email': {
			'name': 'email',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				},
				{
					'type': 'email'
				}
			]
		},
		'birthYear': {
			'name': 'birthYear',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				},
				{
					'type': 'regexp',
					'regexp': new RegExp("^[0-9]{4}$")
				},
				{
					'type': 'range',
					'min': nowDate.getFullYear() - 150,
					'max': nowDate.getFullYear()
				}
			]
		},
		'phone': {
			'name': 'phone',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				},
				{
					'type': 'regexp',
					'regexp': new RegExp("^\\+[0-9\\-\ ]*[0-9]$")
				},
				{
					'type': 'phoneNumber'
				}
			]

		},
		'zipCode': {
			'name': 'zipCode',
			'required': true,
			'validation': [
				{
					'type': 'notBlank'
				},
				{
					'type': 'regexp',
					'regexp': new RegExp("^[0-9]{3} ?[0-9]{2}$")
				},
			]
		},
		'personalDataAgreement': {
			'name': 'personalDataAgreement',
			'required': true,
			'validation': [
				{
					'type': 'true'
				}
			]
		},
		'tariffVariant': {
			'name': 'tariffVariant',
			'required': true,
			'validation': [
				{
					'type': 'true'
				}
			]
		},
		'newsletterAgreement': {
			'name': 'newsletterAgreement',
		},
		'employeeEmail': {
			'name': 'employeeEmail',
			'optional': true,
			'validation': [
				{
					'type': 'email'
				}
			]
		},
		'benefitCode': {
			'name': 'benefitCode',
			'optional': true,
			'validation': [
				{
					'type': 'regexp',
					'regexp': new RegExp("^([A-Z0-9])+$")
				},
				{
					'type': 'length',
					'min': 1,
					'max': 100
				}
			]
		},
		'dedication': {
			'name': 'dedication',
			'required': false,
			'validation': []
		},
	};

	var attachments = {
		maxFileSize: 20971520,
		maxTotalFileSize: 104857600,
		allowedMimeTypes: [
			'audio/mp3',
			'video/x-mpeg',
			'audio/x-mpeg-3',
			'audio/mpeg3',
			'text/plain',
			'video/avi',
			'video/mp4',
			'video/mpeg',
			'video/quicktime',
			'application/pdf',
			'image/png',
			'image/jpg',
			'image/jpeg',
			'image/heif',
			'image/heic',
			'image/heic-sequence',
			'image/heif-sequence',
		],
	}

	return {
		'locale': ulekareBackendVars.locale,
		'isOrder': ulekareBackendVars.isOrder === true,
		'isQuestion': ulekareBackendVars.isOrder !== true,
		'isPartner': ulekareBackendVars.isPartner === true,
		'isPartnerWithoutOrder': ulekareBackendVars.isPartnerWithoutOrder === true,
		'isSubscription': ulekareBackendVars.isSubscription === true,
		'medicalAdvisoryId': ulekareBackendVars.medicalAdvisoryId,
		'paymentMethod': {
			'voucher': 2,
			'partnerEmail': 19
		},
		'paymentStatus': {
			'payment_created': 24,
			'payment_confirmed': 25,
			'payment_canceled': 26,
			'payment_rejected': 27,
			'payment_create_error': 28,
			'payment_timeouted': 29,
			'payment_in_progress': 31
		},
		'status': {
			'question': {
				'ready_to_answer': 3,
				'being_processed_by_ca': 4,
				'assigned_to_specialist': 14,
				'waiting_for_payment': 16,
				'new_specialized': 52
			},
			'order': {
				'new': 48
			},
			'subscription': {
				'done': 51
			}
		},
		'steps': {
			'formServiceSelect': 0,
			'formEnter': 1,
			'tariffSelect': 2,
			'paymentMethodSelect': 3,
			'authorizationForm': 4,
			'thankYou': 5,
			'authorizationRequestSent': 6,
			'authorizationRequestError': 7,
			'authorizationDone': 8,
			'authorizationInvalid': 9,
			'authorizationAlreadyDone': 10,
			'authorizationExpired': 11,
			'paymentError': 12
		},
		'validationFunctions': validationFunctions,
		'questionFormFields': [
			formFieldsDefinition.question,
			formFieldsDefinition.firstName,
			formFieldsDefinition.lastName,
			formFieldsDefinition.email,
			formFieldsDefinition.birthYear,
			formFieldsDefinition.phone,
			formFieldsDefinition.zipCode,
			formFieldsDefinition.personalDataAgreement,
			formFieldsDefinition.newsletterAgreement,
			formFieldsDefinition.tariffVariant
		],
		'orderFormFields': [
			formFieldsDefinition.problem,
			formFieldsDefinition.firstName,
			formFieldsDefinition.lastName,
			formFieldsDefinition.email,
			formFieldsDefinition.birthYear,
			formFieldsDefinition.phone,
			formFieldsDefinition.zipCode,
			formFieldsDefinition.personalDataAgreement,
			formFieldsDefinition.newsletterAgreement,
			formFieldsDefinition.tariffVariant
		],
		'authorizationFormFields': [
			formFieldsDefinition.employeeEmail,
			formFieldsDefinition.benefitCode
		],
		'subscriptionFormFields': [
			formFieldsDefinition.firstName,
			formFieldsDefinition.lastName,
			formFieldsDefinition.email,
			formFieldsDefinition.dedication,
			formFieldsDefinition.personalDataAgreement
		],
		'attachments': attachments,
		'errors': {
			questionIsAlreadyPaid: 'question is already paid'
		}
	};
});
